import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useModal } from '../Components/Modal/ModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';
import stylesSearch from '../styles/Search.module.css';

const Search = ({ closeModal, type }) => {
    const { openModal } = useModal();
    const [cases, setCases] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const bannerShown = Cookies.get('bannerTDltSearchWelcome');        
        const bannerTDltSearchWelcome = 
        <form>
            <h3 style={{marginBottom: '15px', width: '100%'}}>Добро пожаловать в поиск.</h3>
            <a>Поиск происходит по заданному типу дел.</a>
            <a>Тип определяется от страницы, на которой открыт поиск.</a>
            <a style={{color: '#7c7c7c', marginBottom: '20px'}}>Например, если поисковое окно открыто из страницы "Назначения", то поиск происходит по делам с типом "Назначение".</a>
            <a>При нахождении записи, вы можете нажать на неё и откроется новая вкладка с подробной карточкой дела.</a>
            <a>Вы всегда можете вернуться к поиску. Для этого просто перейдите назад на эту страницу в браузере.</a>
        </form>;
        if (!bannerShown) {
            // Если баннер еще не был показан, показываем его
            openModal('Ознакомление с системой', bannerTDltSearchWelcome);
            
            // Устанавливаем куки, чтобы отметить, что баннер был показан
            Cookies.set('bannerTDltSearchWelcome', 'true', { expires: 365 }); // Куки будет храниться 1 год
        }
    }, []);

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
          document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            if (searchTerm !== '') {
                axios.get(`/api/search?searchterm=${searchTerm}&type=${type}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                })
                .then((response) => {
                    if (response.data.length === 0) {
                        setCases([]);
                        setWarning('Ничего не найдено.');
                    } else {
                        setCases(response.data);
                        setWarning('');
                    }
                })
                .catch(error => {
                    console.error('Ошибка получения данных '+error);
                    setWarning(`Ошибка получения данных:  ${error.response?.data.message || error.message}`);
                })
                .finally(() => {
                    setLoading(false);
                })
            }
        } else {
            handleLogout();
        }
    }, [searchTerm])


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Поиск {type=='Все' && ''} {type=='Назначения' && 'по назначениям'} {type=='Жалобы' && 'по жалобам'} {type=='Общие' && 'по общим'}</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    <h2>Введите поисковый запрос:</h2>
                    <input type="text" value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='Поиск по номеру...' />
                    {/* <h2>Выберите тип поиска:</h2>
                    <div style={{display: 'flex'}}>
                        <button type='button' className='miniButton selectedMiniButton' style={{margin: '5px 3px 5px 0'}}>По номеру</button>
                        <button type='button' className='miniButton' style={{margin: '5px 3px 5px 0'}}>По истцу</button>
                        <button type='button' className='miniButton' style={{margin: '5px 3px 5px 0'}}>По арбитражному управляющему</button>
                    </div> */}
                    {loading ? (
                        <Loading />
                    ) 
                    : 
                    (searchTerm=='' ? (
                        <>
                            <a className={stylesSearch.warningLine} style={{textAlign: 'center', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Введите поисковый запрос</a>
                        </>
                    ) : (
                        <>
                            {warning ? ( 
                            <>
                                <a className={stylesSearch.warningLine} style={{textAlign: 'center', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{warning}</a>
                            </>
                            ) : (
                                <>
                                    <h2>Результаты поиска:</h2>
                                    <div className={stylesSearch.header}>
                                        <a className={stylesSearch.dot}></a>
                                        <a className={stylesSearch.number}>Номер</a>
                                        <a className={stylesSearch.applicant}>Истец</a>
                                        <a className={stylesSearch.worker}>Работник</a>
                                        <a className={stylesSearch.status}>Статус</a>
                                    </div>
                                    {cases.map(cases => (
                                        <motion.div
                                            key={cases.id}
                                            initial={{ scale: '97%', opacity: 0 }}
                                            animate={{ scale: '100%', opacity: 1 }}
                                            exit={{ scale: '97%', opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            layout
                                        >
                                            <Link to={`/case/${cases.id}`} className={stylesSearch.case} onClick={(e) => {e.preventDefault(); window.open(`/case/${cases.id}`, '_blank');}}>
                                                <a className={stylesSearch.dot}>
                                                    {cases.status=='В работе' ? (<svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="record-audio"><path fill="#0a469f" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"></path></svg>)
                                                    : (<svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="record-audio"><path fill="#0a9f3c" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"></path></svg>)
                                                    }
                                                </a>
                                                <a className={stylesSearch.number}>{cases.number}</a>
                                                <a className={stylesSearch.applicant}>{cases.applicant}</a>
                                                <a className={stylesSearch.worker}>{cases.user_id ? (cases.user_id) : ('Не определён')}</a>
                                                <a className={stylesSearch.status}>{cases.status}</a>
                                            </Link>
                                        </motion.div>
                                    ))}
                                </>
                            )}
                        </>
                    )
                    )}
                </div>
            </form>
        </div>
    );
};

export default Search;
